import * as Sentry from '@sentry/browser';
import React from 'react';
import { dayjs } from '@/utils/dayjs';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 180px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  letter-spacing: -0.2px;
  color: rgba(16, 25, 56, 0.55);
`;

/**
 * Helper function for the TimestampLog component
 *
 * @param {string} noteDateStr ISO-formatted date-time string in UTC, without timezone
 * (e.g. "2021-07-21T22:56:05.138609")
 * @throws {Error} Throws an error if given a timestamp from the future.
 */
export function beautifyDate(noteDateStr) {
  const noteDate = dayjs.utc(noteDateStr).local();
  const dateToday = dayjs();
  if (noteDate.diff(dateToday) > 0) {
    Sentry.captureException(
      new Error('Displaying future timestamps not supported.')
    );
    return noteDate.format('MM-DD-YYYY, LT');
  }
  /*
   * Using end of day moment because moment.diff calculates 1 day as 24 hours. When comparing
   * "01-01-1970 11:59PM" and "01-02-1970 00:00AM", we want `daysPassed` to be 1, even though
   * there is only a one minute difference
   */
  const EndOfTodayMoment = dateToday.endOf('day');
  const daysPassed = EndOfTodayMoment.diff(noteDate, 'day');
  let dateValue = null;
  if (daysPassed === 0) {
    dateValue = `Today, ${noteDate.format('LT')}`;
  } else if (daysPassed <= 2) {
    const pluralS = daysPassed === 1 ? '' : 's';
    dateValue = `${daysPassed} day${pluralS} ago, ${noteDate.format('LT')}`;
  } else {
    dateValue = noteDate.format('MM-DD-YYYY, LT');
  }
  return dateValue;
}

/**
 * Displays the time an event happened. Even though it is called Timestamp log, it
 * will log DateTimes
 */
export function TimestampLog({ dateTime: noteDateStr }) {
  if (!noteDateStr) {
    return null;
  }
  return <Wrapper>{beautifyDate(noteDateStr)}</Wrapper>;
}
